export default {
  en: {
    title: 'Not sure what to talk about?',
    subtitle: 'Spin the wheel for a random topic.',
  },
  ru: {
    title: 'Не знаете, о чём говорить?',
    subtitle: 'Крутите рулетку — выпадет случайная тема.',
  },
  de: {
    title: 'Du weißt nicht, worüber du sprechen sollst?',
    subtitle: 'Dreh das Rad — ein zufälliges Thema erscheint.',
  },
  pt: {
    title: 'Não sabe do que falar?',
    subtitle: 'Gire a roleta — vai sair um tópico aleatório.',
  },
  fr: {
    title: 'Tu ne sais pas de quoi parler ?',
    subtitle: 'Tourne la roue — un sujet au hasard apparaîtra.',
  },
  es: {
    title: '¿No sabes de qué hablar?',
    subtitle: 'Gira la ruleta — saldrá un tema al azar.',
  },
};
